import { Link } from "react-router";
import LazyImage from "./ui/LazyImage";
import type { Persons, Project } from "../types";
import { Button } from "../components/ui/Button";
import greenLogo from "../assets/images/green-logo.png";

type Props = {
  project?: Project | null;
  managerOverride?: Persons | null;
  isFollowing: boolean;
  loading: boolean;
  onToggleFollow: () => void;
  mode?: "desktop" | "mobile";
  showTitle?: boolean;
  className?: string;
};
export default function ManagerFollowBox({
  project,
  managerOverride = null,
  isFollowing,
  loading,
  onToggleFollow,
  mode = "desktop",
  showTitle = true,
  className = "",
}: Props) {
  const isDesktop = mode === "desktop";
  const manager = managerOverride ?? project?.persons?.[0];

  return (
    <div
      className={
        (isDesktop
          ? "hidden xl:block bg-white shadow-sm !p-2.5 space-y-2.5 xl:rounded-[20px] overflow-hidden"
          : "flex justify-between items-center xl:mx-5 xl:hidden bg-green-02 p-2.5 rounded-b-[20px] overflow-hidden") +
        ` ${className}` 
      }
    >
      {/* title Desc */}
      {isDesktop && showTitle && (
        <span className="text-accent-05 text-base font-semibold">
          مدیر این مجموعه
        </span>
      )}

      {/* info */}
      <div
        className={`flex items-center gap-x-2.5 bg-green-02 xl:p-2.5 rounded-[20px] ${isDesktop ? "h-fit" : "h-fit"}`}
      >
        <div
          className={`object-cover bg-green-01 border border-green-02 overflow-hidden ${
            isDesktop ? "size-[40px] rounded-[10px]" : "size-11 rounded-full"
          }`}
        >
          <LazyImage
            src={manager?.logo || greenLogo}
            alt="تصویر مدیر"
            className="w-full h-full aspect-square object-cover"
          />
        </div>

        <Link to={`/managers/${manager?.id}`} className="flex flex-col">
          {manager?.nickname && (
            <h3 className="text-green-04 text-[10px] font-medium">
              {manager.nickname}
            </h3>
          )}

          <h2
            className={`text-xs font-bold mt-1 ${
              isDesktop ? "text-green-05" : "text-green-04"
            }`}
          >
            {manager?.name}
          </h2>
        </Link>
      </div>

      {/* follow button */}
      <Button
        onClick={onToggleFollow}
        disabled={loading || !manager?.id}
        className={`flex items-center justify-center gap-2 text-[11px] xl:text-[15px] font-medium transition rounded-[10px]
                ${isDesktop ? "w-full" : "xl:hidden ml-3.5"}
                ${
                  isFollowing
                    ? isDesktop
                      ? "bg-green-02 text-green-04 hover:bg-green-02/70"
                      : "text-white bg-green-03 hover:bg-green-03"
                    : ""
                }`}
      >
        {loading ? (
          <span className="size-4 border-2 mx-4 border-current border-t-transparent rounded-full animate-spin" />
        ) : isFollowing ? (
          "دنبال میکنید"
        ) : (
          "دنبال کردن"
        )}
      </Button>
    </div>
  );
}
